import { createListenerMiddleware } from '@reduxjs/toolkit';

import userApi from '../apis/user-api';
import { activeUserSelector } from '../selectors/session-selectors';
import { setActivePropertyId } from '../slices/auth-slice';
import type { AppRootState } from '../store';
import hydrateUserContext from '../thunks/user-context-thunk';

const propertyChangeListenerMiddleware = createListenerMiddleware();

propertyChangeListenerMiddleware.startListening({
  actionCreator: setActivePropertyId,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState() as AppRootState;
    const activeUser = activeUserSelector(state);
    const propertyGroups = userApi.endpoints.propertyGroups.select({
      userId: activeUser!.sso,
    })(state).data?.responseObject;

    const existingPropertyGroup = propertyGroups?.find(
      propertyGroup => propertyGroup.siteUsedId === action.payload
    );

    if (existingPropertyGroup) {
      void listenerApi.dispatch(
        userApi.endpoints.updateLastUsedAddress.initiate({
          params: {
            userId: activeUser!.sso,
            sortOrder: existingPropertyGroup.sortOrder,
            lastUsedAddress: true,
          },
        })
      );
    } else {
      void listenerApi
        .dispatch(
          userApi.endpoints.createPropertyGroups.initiate({
            body: {
              userId: activeUser!.sso,
              siteUsedId: action.payload,
            },
          })
        )
        .unwrap()
        .then(propertyGroupResponse => {
          return listenerApi.dispatch(
            userApi.endpoints.updateLastUsedAddress.initiate({
              params: {
                userId: activeUser!.sso,
                sortOrder: propertyGroupResponse.responseObject?.sortOrder,
                lastUsedAddress: true,
              },
            })
          );
        });
    }
    void listenerApi.dispatch(
      hydrateUserContext({ propertyId: action.payload })
    );
  },
});

export default propertyChangeListenerMiddleware.middleware;
